import React from 'react';
import ReactDOM from 'react-dom';
import Rx from 'rx';
import FloatMenu from 'ub/ui/canvas/FloatMenu.jsx';
import getEditor from 'ub/utils/editor-utils.js';
import ubBanzai from 'ub/control/banzai-features';

const alignElementsEnabled = ubBanzai.features.isAlignElementsEnabled();

let container;

const MENU_HEIGHT = 40;
const PADDING = 5;

const subject = new Rx.Subject();

subject.subscribe(() => render());

const setContainer = (elm) => {
  container = elm;
};

const isImageElm = elm => elm.type === 'lp-pom-image';

const isTextInEditMode = elm =>
  elm.type === 'lp-pom-text' &&
  elm.inEditMode;

const isButtonLinkedToLightbox = elm =>
  elm.type === 'lp-pom-button' &&
  elm.model.linksToInternalLightbox();

const getButtonClearance = (elm) => {
  const hasActionButton =
    isTextInEditMode(elm) ||
    isImageElm(elm) ||
    isButtonLinkedToLightbox(elm);

  return hasActionButton ? 35 : 0;
};

const calculateOffsets = (activeElm, editor) => {
  const isImage = isImageElm(activeElm);
  const transformBox = isImage ? editor.imageTransformBox.e : editor.transformBox.e;
  const transformBoxTop = transformBox.offsetTop;

  let offsetTop;

  if (transformBoxTop < MENU_HEIGHT) {
    offsetTop =
      transformBoxTop +
      activeElm.model.safeGet('geometry.size.height') +
      PADDING +
      getButtonClearance(activeElm);
  } else {
    offsetTop = transformBoxTop - MENU_HEIGHT;
  }

  return {
    offsetTop,
    offsetLeft: transformBox.offsetLeft
  };
};

const shouldShowDistribution = activeElm =>
  activeElm.type === 'lp-multi-select' &&
    activeElm.selection.length > 2;

const shouldShowMenu = activeElm => {
  return activeElm.model.isVisible() &&
    !['lp-pom-block', 'lp-pom-root'].includes(activeElm.type) &&
    !(activeElm.type === 'lp-pom-button' && activeElm.isFormButton());
};

const render = () => {
  if (!alignElementsEnabled) { return; }

  const editor = getEditor();
  const activeElm = editor.activeElement;

  if (!activeElm || !activeElm.model) { return; }

  const { offsetTop, offsetLeft } = calculateOffsets(activeElm, editor);

  const props = {
    offsetTop,
    offsetLeft,
    isVisible: shouldShowMenu(activeElm),
    showDistribution: shouldShowDistribution(activeElm)
  };

  ReactDOM.render(
    React.createElement(FloatMenu, props),
    container
  );
};

export default { render, setContainer, subject };



// WEBPACK FOOTER //
// ./src/ui/canvas/float-menu.js